import { Component, Prop } from 'vue-property-decorator';
import AlumnoRegistro from '@/entities/snp/solicitud/posgrado/alumno/alumno-registro.vue';
import AlumnoListado from '@/entities/snp/solicitud/posgrado/alumno/alumno-listado.vue';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { ParticipacionSnp } from '@/shared/model/snp/alumno.model';

@Component({
  components: {
    'alumno-registro': AlumnoRegistro,
    'alumno-listado': AlumnoListado,
  },
})
export default class AlumnoComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  public toggleActualizarTabla = false;
  public mostrarRegistro = false;
  public mostrarListado = true;

  public alumnoEdicion: ParticipacionSnp = new ParticipacionSnp();

  public actualizarTabla(): void {
    this.alumnoEdicion = new ParticipacionSnp();
    this.toggleActualizarTabla = !this.toggleActualizarTabla;
    this.mostrarRegistro = false;
    this.mostrarListado = true;
  }

  public editarAlumno(alumno: ParticipacionSnp): void {
    this.alumnoEdicion = ParticipacionSnp.fromObject(alumno);
    this.mostrarRegistro = true;
    this.mostrarListado = false;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
